var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKeychainWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h32v32H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.7,7.4c1.7,1,2.7,2.9,2.5,4.8l9.4,5.4c0.1,0.1,0.2,0.2,0.2,0.4l0.2,1.4c0,0.2-0.1,0.4-0.3,0.5l-1.3,0.6 c-0.1,0.1-0.3,0.1-0.5,0l-2-1.1c-0.1-0.1-0.2-0.1-0.2-0.2l-0.4-0.8c-0.1-0.2-0.3-0.3-0.5-0.3l-0.9,0.1c-0.1,0-0.2,0-0.3-0.1L19,16.5 c-0.1-0.1-0.3-0.1-0.5,0l-1.4,0.6c-0.1,0.1-0.3,0.1-0.5,0l-1.4-0.8C13.7,17,12,16.9,10.6,16c-2.4-1.4-3.3-4.5-1.9-6.9 c0.6-1.1,1.7-1.9,2.9-2.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.9,18.5l4.5,7.1c0.1,0.1,0.1,0.3,0,0.4l-0.6,1.4c-0.1,0.2-0.2,0.3-0.4,0.2l-1.5-0.2c-0.1,0-0.3-0.1-0.3-0.2 l-1.2-2c0-0.1-0.1-0.2-0.1-0.3l0.1-1c0-0.2-0.1-0.4-0.2-0.4l-0.9-0.4c-0.1,0-0.1-0.1-0.2-0.2l-1.6-2.7c-0.1-0.1-0.2-0.2-0.3-0.2 h-1.6c-0.1,0-0.3-0.1-0.3-0.2l-0.8-1.4c-1.6-0.2-3.1-1.1-3.9-2.5C5,14.8,4.8,13.6,5,12.3C5.3,10.9,6.2,9.7,7.4,9 M13.2,10.5 c1.4-2.4,0.6-5.4-1.8-6.8S5.9,3.1,4.5,5.5c-0.7,1.2-0.9,2.7-0.4,4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeychainWhite);
export default __webpack_public_path__ + "static/media/ic_keychain_white.725076e83477c2d35878e0e1a2d88535.svg";
export { ForwardRef as ReactComponent };